module.exports = __webpack_public_path__ + "static/media/EM.92766572.png";